export function EmptyState({ icon: Icon, title, description, action }) {
  return (
    <div className="ops-empty-state">
      {Icon && <Icon size={26} strokeWidth={1.6} className="ops-empty-state-icon" />}
      <p className="ops-empty-state-title">{title}</p>
      {description && <p className="ops-empty-state-description">{description}</p>}
      {action && <div className="ops-empty-state-action">{action}</div>}
    </div>
  );
}
